export default __webpack_public_path__ + "static/media/tree20.8f8d73e1.png";